import React, {Component} from 'react';
import Modal from "../../../components/Modal";
import withRouter from "react-router/es/withRouter";
import {CANT_X_PAG, PAG_1} from "../../../actions";
import {fetchObtenerClientes} from '../../../actions'
import {connect} from 'react-redux';
import _ from 'lodash';

const TableTr = (props) => {
    const clientes = props.clientes;
    if (_.isArray(clientes)) {
        return props.clientes.map(cli =>
            <tr key={cli.codigo}>
                <td>{cli.nombre}</td>
                <td>{cli.dni}</td>
                <td>{cli.ruc}</td>
                <td><a className='btn btn-default btn' onClick={() => props.fnClienteSelected(cli)}><i className='ion-android-arrow-dropright'/></a></td>
            </tr>
        )
    }
    return null;
};

class BuscarCliente extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nombreClienteInput: '',
            dniClienteInput: '',
            rucClienteInput: '',
            clienteResponse: [],
            codClienteInput: '',
            modalOpen: ''
        };
        this.obtieneClientes = this.obtieneClientes.bind(this);
        //this.clienteSelected = this.clienteSelected.bind(this);
    }

    obtieneClientes() {
        let cadena = this.state.nombreClienteInput;
        let ruc = this.state.rucClienteInput;
        let dni = this.state.dniClienteInput;
        let codCliente = this.state.codClienteInput;
        this.props.fetchObtenerClientes(cadena, ruc, dni, codCliente, PAG_1, CANT_X_PAG)
            .then(data => {
                this.setState({clienteResponse: data.payload.data.data})
            });
    }

    fnClienteSelected = (item) => {
        console.log(item);
    };

    closeModal = () => {
        this.setState({modalOpen: ''})
    }
    render() {

        return (
            <div>
                <Modal title={'Buscar Cliente'}
                       idModal={'buscar-cliente'}
                       isOpen
                       modalSize={'modal-dialog'}
                       closeModal={this.props.closeModal}>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <label className='control-label'>Nombre
                                    o Raz&oacute;n Social</label>
                                <input id='nombreClienteInput' className='form-control'
                                       value={this.state.nombreClienteInput}
                                       onChange={(e) => {
                                           this.setState({nombreClienteInput: e.target.value});
                                       }}
                                       placeholder='Filtrar por nombre o razón social.'/>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label
                                    className='control-label'>DNI</label>
                                <input className='form-control' value={this.state.dniClienteInput}
                                       onChange={(e) => {
                                           this.setState({dniClienteInput: e.target.value});
                                       }}
                                       placeholder='Ingrese DNI'/>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label
                                    className='control-label'>RUC</label>
                                <input className='form-control' value={this.state.rucClienteInput}
                                       onChange={(e) => {
                                           this.setState({rucClienteInput: e.target.value});
                                       }}
                                       placeholder='Ingrese RUC'/>
                            </div>
                        </div>
                        <div className='col-md-6'></div>
                        <div className='col-md-6'>
                            <button
                                className='btn btn-primary pull-right'
                                onClick={this.obtieneClientes}>Buscar
                            </button>
                        </div>
                    </div>
                    <hr></hr>
                    <div className='row'>
                        <div className='col-md-12'>
                            <table className='table table-hover'>
                                <thead className='table-head'>
                                <tr>
                                    <th>Nombre</th>
                                    <th>DNI</th>
                                    <th>RUC</th>
                                    <th>C&oacute;digo</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <TableTr
                                    clientes={this.state.clienteResponse}
                                    fnClienteSelected={this.fnClienteSelected}
                                />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

BuscarCliente.defaultProps = {
    clienteResponse: []
}

function mapStateToProps(state) {
    return {
        vendedores: state.vendedores
    };
}

export default connect(mapStateToProps, {fetchObtenerClientes})(BuscarCliente);


// WEBPACK FOOTER //
// ./src/pages/modals/BuscarCliente/index.js